import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import TailwindPageWrapper from '../generic/TailwindPageWrapper';

const AccessDenied = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  return (
    <TailwindPageWrapper>
      <div className="flex items-center justify-center px-4 py-12 min-h-[calc(100vh-200px)]">
        <div className="max-w-md w-full text-center">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-6">
              <i className="fas fa-lock text-red-600 text-2xl"></i>
            </div>
            
            <h1 className="text-2xl font-bold text-slate-900 mb-3">
              {t("accessDenied.title", "Zugriff verweigert")}
            </h1>
            
            <p className="text-slate-600 mb-6">
              {t(
                "accessDenied.message",
                "Sie haben keine Berechtigung, auf diese Seite zuzugreifen."
              )}
            </p>

            {isAuthenticated && user && (
              <div className="mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
                <p className="text-sm text-slate-600 mb-2">
                  {t("accessDenied.currentUser", "Angemeldet als:")}
                </p>
                <p className="text-sm font-medium text-slate-900">
                  {user.username} ({user.role?.toUpperCase() || ""})
                </p>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-md hover:bg-slate-800 transition-colors"
              >
                <i className="fas fa-arrow-left text-xs"></i>
                {t("accessDenied.goBack", "Zurück")}
              </button>
              
              <button
                onClick={() => navigate("/admin/dashboard")}
                className="inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-slate-200 text-slate-700 text-sm font-medium rounded-md hover:bg-slate-50 transition-colors"
              >
                <i className="fas fa-home text-xs"></i>
                {t("accessDenied.goToDashboard", "Zum Dashboard")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </TailwindPageWrapper>
  );
};

export default AccessDenied;

